// === File: ./frontend/src/config.js ===
export const BACKEND_URL = process.env.REACT_APP_API_URL;
